var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exchange_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 16h330v60h-330z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 106v150h330v-150zm120 90h-60v-30h60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 391,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452 316c0 16.538 13.462 30 30 30s30-13.462 30-30v-30h-30c-16.538 0-30 13.462-30 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 406c10.977 0 21.14 3.177 30 8.344v-46.688c-8.86 5.167-19.023 8.344-30 8.344-33.091 0-60-26.909-60-60 0-10.977 3.177-21.14 8.344-30h-166.688c5.167 8.86 8.344 19.023 8.344 30 0 33.091-26.909 60-60 60-10.977 0-21.14-3.177-30-8.344v46.688c8.86-5.167 19.023-8.344 30-8.344 33.091 0 60 26.909 60 60 0 10.977-3.177 21.14-8.344 30h166.688c-5.167-8.86-8.344-19.023-8.344-30 0-33.091 26.909-60 60-60zm-135 30c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 436c-16.538 0-30 13.462-30 30s13.462 30 30 30h30v-30c0-16.538-13.462-30-30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212 346c16.538 0 30-13.462 30-30s-13.462-30-30-30h-30v30c0 16.538 13.462 30 30 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242 466c0-16.538-13.462-30-30-30s-30 13.462-30 30v30h30c16.538 0 30-13.462 30-30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 76h150v30h-150z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 316h150v30h-150z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 136h120v30h-120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 376h120v30h-120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 196h60v30h-60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90 436h60v30h-60z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartial);
export default __webpack_public_path__ + "static/media/partial.a6e4919e088b13ee47963e2d00c0aa6a.svg";
export { ForwardRef as ReactComponent };